import { defineComponent, } from "vue";
import SmeLayout from "../../layouts/SmeLayout";
import SmeSupportForm from "../../components/SmeSupportForm";
import Utils from "../../utils/Utils";

export default defineComponent({
    components: {
        SmeLayout,
        SmeSupportForm,
    },

    template: `
        <SmeLayout class="StepSmeContact">
            <div class="wrapper wrapper--464">
                <div class="SmeSupportFormBox contentbox contentbox--white">
                    <h1 class="title-2">Chcesz dowiedzieć się więcej?</h1>

                    <SmeSupportForm type="contact">
                        <p class="SmeSupportFormBox__text">Zamów kontakt z naszym Doradcą.</p>
                    </SmeSupportForm>
                </div>
            </div>
        </SmeLayout>
    `,

    setup(props, ctx) {
        Utils.hideGreenTerms();

        return {
        };
    },
});
